<template>
  <div class="curricular-mesh-info page-break">
    <div class="formation-lines-container">
      <b-table
        bordered
        class="mt-2 formation-lines-table"
        :items="filteredFormationLines"
        :fields="formationLinesFields"
        small
      >
        <template #cell(color)="row">
          <div
            class="formation-line-color"
            :style="{
              'background-color': row.item.color,
              color: row.item.color,
            }"
          ></div>
        </template>
      </b-table>
      <div class="footer-info">
        {{
          $t(
            "curricularMesh.curricularMeshView.inCaseMatterHasNoFormationLine",
            {
              matter: $getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ),
              formationLine: $getVisibleNames(
                "mesh.formationline",
                false,
                "Línea De Formación"
              ),
            }
          )
        }}
        <div
          class="formation-line-color"
          style="background-color: #6b7785; color: #6b7785"
        ></div>
      </div>
    </div>
    <div
      class="formation-lines-container"
      v-if="filteredCertifications.length > 0 || allows_crud"
    >
      <b-table
        bordered
        class="mt-2 ml-1 formation-lines-table"
        :items="filteredCertifications"
        :fields="certifications_fields"
        small
        show-empty
      >
        <template #head(name)>
          <div class="d-flex" style="align-items: center">
            <ButtonSmall
              v-if="allows_crud && can_update"
              v-can="'mesh.add_certification'"
              :tooltip_text="
                $t('reusable.common.addTooltip', {
                  entity: $getVisibleNames(
                    'mesh.certification',
                    false,
                    'Certificación de Credenciales'
                  ),
                })
              "
              :click_button="() => $bvModal.show(`new-certification-modal`)"
              :class="` mr-1`"
              :icon="'plus'"
              :custom_class="'text-white'"
            ></ButtonSmall>
            <!-- <button-add
              v-if="allows_crud && can_update"
              v-can="'mesh.add_certification'"
              @click="$bvModal.show(`new-certification-modal`)"
              v-b-tooltip.v-secondary.noninteractive="
                `${$t('reusable.common.add')} ${$getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                )}`
              "
            >
            </button-add> -->
            <span>
              {{
                $getVisibleNames(
                  "mesh.certification",
                  true,
                  "Certificaciones de Credenciales"
                )
              }}
            </span>
          </div>
        </template>
        <template #empty>
          {{ $t("reusable.common.noDataToShow") }}
        </template>
        <template #cell(description)="row">
          <div
            v-if="
              row.item.description && row.item.description.trim().length > 0
            "
            class="certification-description text-left"
          >
            <RenderVHtml :content="row.item.description"></RenderVHtml>
          </div>
          <div v-else class="text-center">-</div>
        </template>
        <template #cell(matters)="row">
          <div class="campus-container">
            <div
              v-for="item in getMatterName(row.item.matters)"
              :key="item.id"
              class="campus-div"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-if="allows_crud && can_update"
            v-can="'mesh.change_certification'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-certification-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <!-- <button-edit
            v-if="allows_crud && can_update"
            v-can="'mesh.change_certification'"
            @click="$bvModal.show(`edit-certification-modal-${row.item.id}`)"
            v-b-tooltip.v-secondary.noninteractive="
              `${$t('reusable.common.edit')} ${$getVisibleNames(
                'mesh.certification',
                false,
                'Certificación de Credenciales'
              )}`
            "
          ></button-edit> -->
          <ButtonSmall
            v-if="allows_crud && can_delete"
            v-can="'mesh.delete_certification'"
            :click_button="() => askForDeleteCertification(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            :class="`mx-1`"
            :icon="'trash'"
          ></ButtonSmall>
          <!-- <button-delete
            v-if="allows_crud && can_delete"
            v-can="'mesh.delete_certification'"
            @click="askForDeleteCertification(row.item.id)"
            v-b-tooltip.v-secondary.noninteractive="
              `${$t('reusable.common.delete')} ${$getVisibleNames(
                'mesh.certification',
                false,
                'Certificación de Credenciales'
              )}`
            "
          ></button-delete> -->
          <b-modal
            :id="`edit-certification-modal-${row.item.id}`"
            :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
              'mesh.certification',
              false,
              'Certificación de Credenciales'
            )}`"
            size="lg"
            hide-footer
          >
            <CertificationForm
              :Certification="row.item"
              :EgressProfile="egressProfile"
              @updated="
                $bvModal.hide(`edit-certification-modal-${row.item.id}`)
              "
              :show_title="false"
            ></CertificationForm>
          </b-modal>
        </template>
      </b-table>
    </div>
    <div>
      <div class="formation-lines-container" v-if="modalities.length > 0">
        <b-table
          bordered
          class="mt-2 ml-1 formation-lines-table"
          :items="modalities"
          :fields="modalities_fields"
          small
        >
          <template #cell(matters)="row">
            <div class="campus-container">
              <div
                v-for="item in getMatterName(row.item.matters)"
                :key="item.id"
                class="campus-div"
              >
                {{ item.name }}
              </div>
            </div>
          </template>
        </b-table>
      </div>
      <div
        class="footer-info text-left"
        v-if="
          institution &&
          institution.internal_use_id == 'duoc.cl' &&
          egressProfile &&
          egressProfile.intermediate_output_semester > 0
        "
      >
        <div>
          {{
            $t(
              "curricularMesh.curricularMeshView.indicatesIntermediateOutputSemester"
            )
          }}
        </div>
      </div>
    </div>
    <EgressProfileCompetenceMention
      v-if="
        egress_profile_id &&
        profile_competences_mention.filter(
          (x) => x.egress_profile == egress_profile_id
        ).length > 0
      "
      style="width: 400px"
      :allows_crud="false"
      :egress_profile_id="egress_profile_id"
      :curricular_mesh="true"
    ></EgressProfileCompetenceMention>
    <div class="formation-lines-container" v-if="coursesWrapperList.length > 0">
      <b-table
        bordered
        class="mt-2 formation-lines-table"
        :items="coursesWrapperList"
        :fields="courses_wrapper_fields"
        small
      >
        <template #cell(egress_profile_matters)="row">
          <div class="campus-container">
            <div
              v-for="item in getEgressProfileMatterName(
                row.item.egress_profile_matters
              )"
              :key="item.id"
              class="campus-div"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div
      class="formation-lines-container"
      v-if="
        formationAreasMatters.length > 0 &&
        institution &&
        institution.internal_use_id == 'duoc.cl'
      "
    >
      <b-table
        bordered
        class="mt-2 ml-1 formation-lines-table"
        :items="formationAreasMatters"
        :fields="formationAreasHoursFields"
        small
        foot-clone
      >
        <template v-slot:foot(name)>
          <strong>
            {{ $t("curricularMesh.curricularMeshView.total").toUpperCase() }}
          </strong>
        </template>
        <template v-slot:foot(pedagogical_hours)>
          <strong>{{ totalFormationAreasHours }}</strong>
        </template>
        <template v-slot:foot(credits)>
          <strong>{{ totalFormationAreasCredits }}</strong>
        </template>
      </b-table>
    </div>

    <div class="d-flex matter-card-container">
      <div class="matter-card noprint">
        <div class="left-col">
          <div class="left-label" id="matter-number-box">1</div>
          <div class="left-label" id="hour-modules-box">2</div>
          <div class="left-label" id="matter-credits-box">3</div>
          <div class="left-label" id="modalities-box">4</div>
          <b-popover
            target="matter-number-box"
            placement="topleft"
            triggers="hover"
            v-b-visible
            :content="`${$t(
              'curricularMesh.curricularMeshView.orderNumberOf'
            )} ${$getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            )}`"
          ></b-popover>
          <b-popover
            custom-class="example-popover-1"
            target="hour-modules-box"
            placement="left"
            :offset="-50"
            triggers="hover"
          >
            <template #default>
              <div class="hour-modules-popover-content">
                <template
                  v-if="
                    institution &&
                    institution.internal_use_id !=
                      'dionisioromerouniversity.com'
                  "
                >
                  {{
                    $getVisibleNames(
                      "manual.total_pedagogical_hours",
                      true,
                      "Total de Horas Pedagógicas"
                    )
                  }}
                </template>
                <template v-else>
                  {{
                    $getVisibleNames(
                      "manual.total_chronological_hours",
                      true,
                      "Total de Horas Cronológicas"
                    )
                  }}
                </template>
              </div>
            </template>
          </b-popover>
          <b-popover
            custom-class="example-popover-2"
            target="matter-credits-box"
            placement="left"
            triggers="hover"
            :offset="50"
            :content="`${this.$getVisibleNames(
              'manual.credits',
              true,
              'Créditos SCT'
            )}`"
          ></b-popover>
          <b-popover
            target="modalities-box"
            placement="bottomleft"
            triggers="hover"
            :content="
              $getVisibleNames(
                'mesh.modality',
                false,
                'Modalidad de Asignaturas'
              )
            "
          ></b-popover>
        </div>
        <div class="matter-title">
          <div class="matter-link">
            <div class="container-code-name">
              <b-badge variant="none" pill class="code-matter mb-1">
                {{ $getVisibleNames("manual.matter_code", false, "Código") }}
              </b-badge>
              <span>
                {{
                  $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="right-col">
          <div class="preq-label" id="prerequisites-box">
            5
            <b-popover
              target="prerequisites-box"
              triggers="hover"
              placement="top"
            >
              <template>
                <div>
                  {{ $t("curricularMesh.curricularMeshView.prerequisites") }}
                </div>
              </template>
            </b-popover>
          </div>
          <template>
            <div class="comp-label" id="competences-box">
              <template>
                <div>6</div>
              </template>
              <b-popover
                target="competences-box"
                triggers="hover"
                placement="righttop"
              >
                <template #default>
                  {{
                    $getVisibleNames("mesh.competence", true, "Competencias")
                  }}
                </template>
              </b-popover>
            </div>
          </template>
          <template
            v-if="$hasInstitutionalCredits(institution)"
          >
            <div class="inst-credits-label" id="institutional-credits-box">
              <template>
                <div>7</div>
              </template>
              <b-popover
                target="institutional-credits-box"
                triggers="hover"
                placement="righttop"
              >
                <template #default>
                  {{
                    $getVisibleNames(
                      "manual.institutional_credits",
                      true,
                      "Créditos Institucionales"
                    )
                  }}
                </template>
              </b-popover>
            </div>
          </template>
        </div>
      </div>
      <div>
        <b-table
          class="ml-4 formation-lines-table noprint"
          :items="matterCardList"
          :fields="matter_card_fields"
          bordered
          small
        >
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "CurricularMeshOtherTables",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    CertificationForm: () =>
      import(
        "@/components/mesh/CurricularResources/Certification/CertificationForm"
      ),
    EgressProfileCompetenceMention: () =>
      import("@/components/mesh/EgressProfile/EgressProfileCompetenceMention"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: false,
    },
    can_update: {
      type: Boolean,
      required: false,
    },
    can_delete: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      matters: names.MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      institution: "getInstitution",
      certifications: names.CERTIFICATIONS,
      careers: names.CAREERS,
      formationAreas: names.FORMATION_AREAS,
      formation_lines: names.FORMATION_LINES,
      modalities: names.MODALITIES,
      courses_wrapper: names.COURSES_WRAPPER,
      profile_competences_mention: names.PROFILE_COMPETENCES_MENTION,
      regimes: names.REGIMES,
      profile_types: names.PROFILE_TYPES,
      time_allocations: names.TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
    }),
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    egressProfilesMatters() {
      return this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    coursesWrapperList() {
      return this.courses_wrapper
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          if (a.init_level < b.init_level) return -1;
          if (a.init_level > b.init_level) return 1;
          if (a.end_level < b.end_level) return -1;
          if (a.end_level > b.end_level) return 1;
          return 0;
        });
    },
    wrapperMatterIds() {
      let list = [];
      this.coursesWrapperList.forEach((x) => {
        list = list.concat(x.egress_profile_matters);
      });
      return [...new Set(list)];
    },
    matterList() {
      return this.egress_profiles_matters.filter(
        (x) =>
          x.egress_profile == this.egress_profile_id &&
          !this.wrapperMatterIds.includes(x.id)
      );
    },
    formationLinesMatterIds() {
      const formation_line_ids = this.matterList
        .filter((x) => x.formation_line != null)
        .map((x) => x.formation_line);
      return [...new Set(formation_line_ids)];
    },
    formationLinesCourseWrapperIds() {
      const formation_line_ids = this.coursesWrapperList
        .filter((x) => x.formation_line != null)
        .map((x) => x.formation_line);
      return [...new Set(formation_line_ids)];
    },
    profileType() {
      if (!this.egressProfile) return null;
      return this.profile_types.find(
        (x) => x.id == this.egressProfile.egress_profile_type
      );
    },
    isAnual() {
      if (!this.egressProfile) return null;
      const months_amount_egress_profile = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (months_amount_egress_profile) {
        if (months_amount_egress_profile.months_amount == 6)
          return this.regimes.find(
            (x) =>
              x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
          );
        else if (months_amount_egress_profile.months_amount == 3)
          return this.regimes.find(
            (x) =>
              x.name.includes("Semestral") || parseInt(x.months_amount) / 3 == 2
          );
        else if (months_amount_egress_profile.months_amount == 2)
          return this.regimes.find(
            (x) =>
              x.name.includes("Trimestral") || parseInt(x.months_amount) == 3
          );
      }
      return this.regimes.find(
        (x) => x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
      );
    },
    formationAreasMatters() {
      const areas = [];
      this.formationAreas.forEach((area) => {
        const mattersInArea = this.matterList.filter(
          (matter) => matter.formation_area == area.id
        );
        let totalPedagogical = 0;
        let totalCredits = 0;
        const pedagogical_hours_ids = this.time_allocations
          .filter((x) => x.uses_module_minutes == true)
          .map((x) => x.id);
        mattersInArea.forEach((matter) => {
          // Calcular créditos
          if (matter.use_matter_values) {
            const old_matter = this.matters.find((x) => x.id == matter.matter);
            if (old_matter) {
              if (this.isAnual && matter.regime == this.isAnual.id) {
                totalCredits += parseFloat(
                  old_matter.institutional_credits || 0
                );
              } else {
                totalCredits += parseFloat(
                  old_matter.institutional_credits || 0
                );
              }
            }
          } else {
            if (this.isAnual && matter.regime == this.isAnual.id) {
              totalCredits += parseFloat(matter.institutional_credits || 0);
            } else {
              totalCredits += parseFloat(matter.institutional_credits || 0);
            }
          }

          // Calcular horas pedagógicas
          let pedagogical_matter_hours = [];
          if (matter.use_matter_values) {
            pedagogical_matter_hours = this.matter_time_allocations.filter(
              (x) =>
                x.matter == matter.matter &&
                pedagogical_hours_ids.includes(x.time_allocation) &&
                x.counts_towards_credits == true
            );
          } else {
            pedagogical_matter_hours = this.ep_matter_time_allocations.filter(
              (x) =>
                x.egress_profile_matter == matter.id &&
                pedagogical_hours_ids.includes(x.time_allocation) &&
                x.counts_towards_credits == true
            );
          }
          pedagogical_matter_hours.forEach((hour) => {
            let current_hours = hour.hours;
            if (
              this.institution &&
              parseInt(this.institution.hour_decimal_places) === 0
            )
              current_hours = Math.round(current_hours);
            if (this.isAnual && matter.regime == this.isAnual.id) {
              totalPedagogical += parseFloat(current_hours);
            } else {
              totalPedagogical += parseFloat(current_hours);
            }
          });
        });

        // Agregar horas pedagógicas y créditos de courses_wrapper (formación optativa)
        const wrappersInArea = this.coursesWrapperList.filter(
          (wrapper) => wrapper.formation_area == area.id
        );
        wrappersInArea.forEach((wrapper) => {
          if (wrapper.institutional_credits) {
            totalCredits += parseFloat(wrapper.institutional_credits);
          }
          if (wrapper.hours) {
            totalPedagogical += parseFloat(wrapper.hours);
          }
        });
        if (totalPedagogical > 0) {
          const decimal_places =
            this.institution &&
            parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2;

          areas.push({
            id: area.id,
            name: area.name,
            pedagogical_hours:
              this.institution &&
              parseInt(this.institution.hour_decimal_places) === 0
                ? Math.round(totalPedagogical)
                : parseFloat(totalPedagogical.toFixed(decimal_places)),
            credits: Math.round(totalCredits),
          });
        }
      });

      // Calcular asignaturas sin área de formación
      const mattersWithoutArea = this.matterList.filter(
        (matter) => !matter.formation_area || matter.formation_area === null
      );

      // Verificar también courses_wrapper sin área de formación
      const wrappersWithoutArea = this.coursesWrapperList.filter(
        (wrapper) => !wrapper.formation_area || wrapper.formation_area === null
      );

      if (mattersWithoutArea.length > 0 || wrappersWithoutArea.length > 0) {
        let totalPedagogicalNoArea = 0;
        let totalCreditsNoArea = 0;

        const pedagogical_hours_ids = this.time_allocations
          .filter((x) => x.uses_module_minutes == true)
          .map((x) => x.id);

        mattersWithoutArea.forEach((matter) => {
          // Calcular créditos
          if (matter.use_matter_values) {
            const old_matter = this.matters.find((x) => x.id == matter.matter);
            if (old_matter) {
              if (this.isAnual && matter.regime == this.isAnual.id) {
                totalCreditsNoArea += parseFloat(old_matter.credits || 0);
              } else {
                totalCreditsNoArea += parseFloat(old_matter.credits || 0);
              }
            }
          } else {
            if (this.isAnual && matter.regime == this.isAnual.id) {
              totalCreditsNoArea += parseFloat(matter.credits || 0);
            } else {
              totalCreditsNoArea += parseFloat(matter.credits || 0);
            }
          }

          // Calcular horas pedagógicas
          let pedagogical_matter_hours = [];
          if (matter.use_matter_values) {
            pedagogical_matter_hours = this.matter_time_allocations.filter(
              (x) =>
                x.matter == matter.matter &&
                pedagogical_hours_ids.includes(x.time_allocation) &&
                x.counts_towards_credits == true
            );
          } else {
            pedagogical_matter_hours = this.ep_matter_time_allocations.filter(
              (x) =>
                x.egress_profile_matter == matter.id &&
                pedagogical_hours_ids.includes(x.time_allocation) &&
                x.counts_towards_credits == true
            );
          }

          pedagogical_matter_hours.forEach((hour) => {
            let current_hours = hour.hours;
            if (
              this.institution &&
              parseInt(this.institution.hour_decimal_places) === 0
            )
              current_hours = Math.round(current_hours);

            if (this.isAnual && matter.regime == this.isAnual.id) {
              totalPedagogicalNoArea += parseFloat(current_hours);
            } else {
              totalPedagogicalNoArea += parseFloat(current_hours);
            }
          });
        });

        // Agregar horas pedagógicas y créditos de courses_wrapper sin área de formación
        wrappersWithoutArea.forEach((wrapper) => {
          if (wrapper.institutional_credits) {
            totalCreditsNoArea += parseFloat(wrapper.institutional_credits);
          }
          if (wrapper.hours) {
            totalPedagogicalNoArea += parseFloat(wrapper.hours);
          }
        });

        // Solo agregar si hay horas o créditos
        if (totalPedagogicalNoArea > 0 || totalCreditsNoArea > 0) {
          const decimal_places =
            this.institution &&
            parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2;

          areas.push({
            id: "without_area",
            name: `Sin ${this.$getVisibleNames(
              "mesh.formationarea",
              false,
              "Área de Formación"
            )}`,
            pedagogical_hours:
              this.institution &&
              parseInt(this.institution.hour_decimal_places) === 0
                ? Math.round(totalPedagogicalNoArea)
                : parseFloat(totalPedagogicalNoArea.toFixed(decimal_places)),
            credits: Math.round(totalCreditsNoArea),
          });
        }
      }

      return areas.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    totalFormationAreasHours() {
      let total = 0;
      this.formationAreasMatters.forEach((area) => {
        total += parseFloat(area.pedagogical_hours || 0);
      });

      const decimal_places =
        this.institution && parseInt(this.institution.hour_decimal_places) > 0
          ? parseInt(this.institution.hour_decimal_places)
          : 2;

      return this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0
        ? Math.round(total)
        : parseFloat(total.toFixed(decimal_places));
    },
    totalFormationAreasCredits() {
      let total = 0;
      this.formationAreasMatters.forEach((area) => {
        total += parseFloat(area.credits || 0);
      });
      return Math.round(total);
    },
    filteredFormationLines() {
      if (!this.career) return [];
      return this.formation_lines
        .filter(
          (x) =>
            x.faculties.includes(this.career.faculty) &&
            (this.formationLinesMatterIds.includes(x.id) ||
              this.formationLinesCourseWrapperIds.includes(x.id))
        )
        .sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
    filteredCertifications() {
      if (!this.egressProfile) return [];
      return this.certifications
        .filter((x) => x.egress_profile == this.egressProfile.id)
        .sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
    matterCardList() {
      let list = [
        {
          id: 1,
          order: 1,
          name: `${this.$t(
            "curricularMesh.curricularMeshView.orderNumberOf"
          )} ${this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          )}`,
        },
        {
          id: 2,
          order: 2,
          name:
            this.institution &&
            this.institution.internal_use_id != "dionisioromerouniversity.com"
              ? this.$getVisibleNames(
                  "manual.total_pedagogical_hours",
                  true,
                  "Total de Horas Pedagógicas"
                )
              : this.$getVisibleNames(
                  "manual.total_chronological_hours",
                  true,
                  "Total de Horas Cronológicas"
                ),
        },
        {
          id: 3,
          order: 3,
          name: `${this.$getVisibleNames(
            "manual.credits",
            true,
            "Créditos SCT"
          )}`,
        },
        {
          id: 4,
          order: 4,
          name: `${this.$getVisibleNames(
            "mesh.modality",
            false,
            "Modalidad de Asignaturas"
          )}`,
        },
        {
          id: 5,
          order: 5,
          name: this.$t("curricularMesh.curricularMeshView.prerequisites"),
        },
        {
          id: 6,
          order: 6,
          name: `${this.$getVisibleNames(
            "mesh.competence",
            true,
            "Competencias"
          )}`,
        },
      ];
      if (this.$hasInstitutionalCredits(this.institution))
        list.push({
          id: 7,
          order: 7,
          name: `${this.$getVisibleNames(
            "manual.institutional_credits",
            true,
            "Créditos Institucionales"
          )}`,
        });
      return list;
    },
    formationAreasHoursFields() {
      const fields = [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.formationarea",
              false,
              "Área de Formación"
            )
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-left",
        },
        {
          key: "pedagogical_hours",
          label: this.$getVisibleNames(
            "manual.total_pedagogical_hours",
            true,
            "Total de Horas Pedagógicas"
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-center",
        },
        {
          key: "credits",
          label: this.$getVisibleNames(
            "manual.institutional_credits",
            true,
            "Créditos Institucionales"
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-center",
        },
      ];

      return fields;
    },
    formationLinesFields() {
      return [
        {
          key: "name",
          label: this.career
            ? String(
                this.$getVisibleNames(
                  "mesh.formationline",
                  true,
                  "Líneas De Formación"
                )
              ) +
              " " +
              String(
                this.$getVisibleNames("mesh.career", false, "Programa") + ": "
              ) +
              this.career.name
            : String(
                this.$getVisibleNames(
                  "mesh.formationline",
                  true,
                  "Líneas De Formación"
                )
              ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-left",
        },
        {
          key: "color",
          label: this.$t("reusable.common.color"),
          sortable: false,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
            verticalAlign: "middle",
          },
        },
      ];
    },
    certifications_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.certification",
              true,
              "Certificaciones de Credenciales"
            )
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "text-left",
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: false,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "",
        },
        {
          key: "matters",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "text-left",
        },
        {
          key: "actions",
          label: "",
          thStyle: this.allows_crud
            ? {
                background: "var(--kl-color-accent-medium) !important",
                color: "var(--kl-text-on-primary) !important",
              }
            : { display: "none" },
          thClass: this.allows_crud ? "noprint" : "d-none",
          tdClass: this.allows_crud ? "noprint" : "d-none",
        },
      ];
    },
    courses_wrapper_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.coursewrapper",
              false,
              "Envoltorio de Asignaturas"
            )
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "text-left",
        },
        {
          key: "credits",
          label: this.$getVisibleNames(
            "manual.credits",
            true,
            "Créditos SCT Totales"
          ),
          sortable: false,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "text-center",
        },
        {
          key: "egress_profile_matters",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          thClass: "align-middle",
          tdClass: "text-left",
        },
      ];
    },
    modalities_fields() {
      return [
        {
          key: "order",
          label: this.$t("curricularMesh.curricularMeshView.number"),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.modality",
              true,
              "Modalidades de Asignaturas"
            )
          ),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-left",
        },
      ];
    },
    matter_card_fields() {
      return [
        {
          key: "order",
          label: this.$t("curricularMesh.curricularMeshView.number"),
          sortable: false,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "name",
          label: this.$t("reusable.common.name"),
          sortable: true,
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "var(--kl-text-on-primary) !important",
          },
          tdClass: "text-left",
        },
      ];
    },
  },
  methods: {
    getEgressProfileMatterName(egress_profile_matters) {
      let matters = this.egress_profiles_matters
        .filter((x) => egress_profile_matters.includes(x.id))
        .map((x) => x.matter);
      matters = [...new Set(matters)];
      if (matters.length > 0) {
        const list = this.matters.filter((element) =>
          matters.includes(element.id)
        );
        return list.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
      } else return [];
    },
    getMatterName(matters) {
      if (matters.length > 0) {
        const list = this.matters.filter((element) =>
          matters.includes(element.id)
        );
        return list.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
      } else return [];
    },
    askForDeleteCertification(certification_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.certification",
            false,
            "Certificación de Credenciales"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_CERTIFICATION, certification_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.certification",
                    false,
                    "Certificación de Credenciales"
                  ) + ` ${this.$t("reusable.common.deleted")}`
                )
              );
            });
        }
      });
    },
  },
  created() {},
};
</script>

<style scoped src="@/utils/rich_text_editor.css"></style>

<style scoped>
.page-break {
  page-break-before: always;
  page-break-after: auto;
  page-break-inside: avoid;
}

.formation-lines-container {
  width: 500px;
}
.formation-lines-table,
.footer-info {
  font-size: 10pt;
}
.formation-line-color {
  padding: 0 1rem;
  max-width: 4rem;
  margin-inline: auto;
}
.formation-line-color::before {
  content: " #";
}

.curricular-mesh-info {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.certification-description {
  max-height: 125px;
  overflow: auto;
}
.matter-card-container {
  margin: 1em 1em;
}
.example-popover-1 {
  top: 5px !important;
}
.example-popover-1 >>> .arrow {
  top: 15px !important;
  margin: 0 !important;
}
.example-popover-2 {
  top: 7px !important;
}
.example-popover-2 >>> .arrow {
  top: -5px !important;
  margin: 0;
  margin-top: 0.45rem !important;
}

.popover.b-popover {
  display: block !important;
  opacity: 1 !important;
}
.matter-card {
  min-width: 160px;
  min-height: 80px;
  max-height: 100px;
  box-sizing: border-box;
  display: flex;
  font-size: var(--thirth-font-size);
  color: #2e2e2e;
}
.matter-title {
  padding: 10px 6px;
  width: 100%;
  font-size: var(--thirth-font-size);
  background-color: #f4f4f4;
  border: 1px solid #7c7c7c;
  margin-bottom: 0;
  background: #6b7785;
}
.matter-title .matter-link {
  background-color: rgb(241, 241, 241);
  min-height: 80px;
  padding: 0.25rem;
  border-radius: 12px;
  line-height: 1.2;
}
.matter-link {
  min-width: 7rem;
}
.matter-link > a {
  color: #2e2e2e !important;
  text-decoration: underline;
}
.matter-link > a:hover {
  color: var(--kl-color-primary) !important;
}
.left-col {
  width: 30px;
  float: left;
  background: transparent;
  font-size: var(--thirth-font-size);
}
.right-col {
  width: 40px;
  background: transparent;
  font-size: var(--thirth-font-size);
}

.left-label,
.preq-label,
.comp-label,
.inst-credits-label {
  color: #2e2e2e;
  background: transparent;
  transition: 0.2s ease-out;
}

.preq-label,
.comp-label,
.inst-credits-label {
  width: 40px;
  height: auto;
  border: 1px solid #575757;
  border-style: solid solid solid none;
  margin-bottom: 0px;
  font-size: 8pt;
}
.inst-credits-label {
  border-style: none solid solid none !important;
}

.left-label {
  height: 20px;
  width: 30px;
  border-top: 1px solid #575757;
  border-bottom: 1px solid #575757;
  border-left: 1px solid #575757;
}
.preq-label {
  padding-left: 0.1em;
  border-bottom: 0 !important;
}
.campus-div {
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  max-width: fit-content;
  border-radius: var(--kl-radius-pill);
  margin: 0.1em 0.1em;
  padding: var(--kl-chip-padding);
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
.code-matter {
  border: 1px solid var(--kl-border-black);
  /* display: flex; */
  align-items: center;
  justify-content: center;
  font-size: 7pt;
  letter-spacing: 0.3px;
}
.container-code-name {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.formation-lines-table >>> tfoot {
  background-color: var(--kl-surface-muted);
  font-weight: bold;
}

.formation-lines-table >>> tfoot td {
  border-top: 2px solid var(--kl-border-black);
}

.without-area-row {
  background-color: #fff3cd;
  font-style: italic;
}

@media print {
  .certification-description {
    max-height: none;
  }
  .left-col {
    display: none !important;
  }
  .right-col {
    display: none !important;
  }
  .left-label {
    display: none !important;
  }
  .formation-lines-table,
  .footer-info {
    font-size: 16px !important;
  }
}
</style>
